/**
 * 　(c) 2018 TERAOKA SEIKO CO., LTD. / 株式会社 寺岡精工
 * 　CONFIDENTIAL / 社外秘
 * 　無断開示・無断複製禁止
 */
<script>
/**
 * 詳細画面コンポーネント ミックスイン
 * @vuedoc
 * @exports js/common/wndDetailBaseMixin
 */
export default {
	props:{
		'r_messages': {
			type: Object,
			required: true
		},
		'r_settings':{
			type: Object,
			required: true
		},
		'r_is_new':{
			type: Boolean,
			default: false
		},
		'r_info': {
			required: true
		},
		'r_info_edit':{},
		'r_code_name':{
			type: String,
		},
		'r_code2_name':{
			type: String,
		},
		'r_class_code': null,
		'r_class_name':null,
		'r_class_text_cl': null,
		'r_is_previous_next_btn':{
			type: Boolean,
			default:false,
		},
		'r_btn_type':{
			type: Number,
			default: 1,
		},
		'r_is_apply':{
			type: Boolean,
			default: true,
		},
	},
	mixins: [
		require('js/common/Edit.mixin.vue'),
		// 表示アニメーション処理
		require('js/common/disptimer.mixin.vue'),
		// TABインデックス制御（Confirm版）
		require('js/common/tabIndexConfirm.mixin.vue'),
	],
	/**
	 * @member
	 * @instance
	 * @prop {string[]} m_strCode - コピー元データ
	 * @prop {bool} m_bConfirmEnable - 確定フラグ
	 * @prop {bool} m_bCopyEnable - コピーフラグ
	 * @prop {bool} m_bDeleteEnable - 消去フラグ
	 * @prop {bool} m_bNewDataDisp - 新規追加フラグ
	 * @prop {bool} m_bEditDataDisp - 編集フラグ
	 * @prop {bool} m_bRestoreEnable - 更新（リロード）フラグ
	 * @prop {object} m_info -詳細データ
	 * @prop {bool} m_bNew - 新規フラグ
	 * @prop {object} m_message - メッセージ
	 * @prop {bool} m_bCopySearchDisp - コピー元選択画面表示フラグ
	 **/
	data: function (){
		return{
			m_strCode: "",
			m_strCode2: "",
			m_bConfirmEnable: false,
			m_bCopyEnable: false,
			m_bDeleteEnable: false,
			m_bRestoreEnable: false,
			m_bNewDataDisp: false,
			m_bEditDataDisp: false,
			m_bCopyDisp: true,
			m_bDeleteDisp: true,
			m_bErrDetailDisp: false,
			m_info: null,
			m_infoEdit:null,			//!< 編集中データ
			m_bNew: false,
			m_message: {errmessage: ""},
			m_bCopySearchDisp: false,		//!< コピー元選択画面表示フラグ
			m_bResetMessage: true,		//!< messageをリセットしても良いか
			m_bResetCode2: false,		//!< messageをリセットしても良いか
			m_isReproduction: false, // 複写フラグ
			m_isFreeNumSearch: false,
			edit_btn_disp: false,
		}
	},
	created: function () {
		// データ初期化
		// ※ この段階では func は使用できない
		this.m_strCode = "";
		this.m_strCode2 = "";
		this.m_info = $.extend(true,{},this.r_info);
		// ドラック用ダイアログID記載
		this.m_dragID = "detail-view"
		this.m_bNew = this.r_is_new;
	},
	mounted: function() {
		// createdより後に呼ばれる（DOMの操作が可能）
		this.$nextTick(function () {
			this.blurActiveElement();
		});
	},
	/**
	 * @instance
	 **/
	computed: {
		//! コンポーネントアクセス
		v_cpsearch : function(){
			return this.$refs.v_cpsearch;
		},
		//! コンポーネントアクセス
		v_msg : function(){
			return this.$refs.v_msg;
		},
		//! コンポーネントアクセス
		v_param : function(){
			return this.$refs.v_param;
		},
		is_confirm_enable: function(){
			return this.$refs.func.is_confirm_enable;
		},
		is_copy_enable: function(){
			return this.$refs.func.is_copy_enable;
		},
		is_delete_enable: function(){
			return this.$refs.func.is_delete_enable;
		},
		is_restore_enable: function(){
			return this.$refs.func.is_restore_enable;
		},
		is_disp_new_btn: function(){
			return this.$refs.func.is_disp_new_btn;
		},
		is_disp_edit_btn: function(){
			return this.$refs.func.is_disp_edit_btn;
		},
		is_disp_copy_btn: function(){
			if(this.$refs.func.is_disp_copy_btn != null) {
				return this.$refs.func.is_disp_copy_btn;
			}
			return true;
		},
		is_disp_delete_btn: function(){
			if(this.$refs.func.is_disp_delete_btn != null) {
				return this.$refs.func.is_disp_delete_btn;
			}
			return true;
		},
		is_disp_errdetail_btn: function(){
			console.log('wndDetailBase : is_disp_errdetail_btn');
			if(this.$refs.func.is_disp_errdetail_btn != undefined) {
				console.log('is_disp_errdetail_btn = ' + this.$refs.func.is_disp_errdetail_btn);
				return this.$refs.func.is_disp_errdetail_btn;
			}
			console.log('is_disp_errdetail_btn = false');
			return false;
		},
		msg_confirm_move_delete:function(){
			// r_messages が存在することが前提の実装
			return this.r_messages.delete_check_text;
		},
		// 予約取り下げ確認メッセージ
		msg_confirm_discharge_res:function(){
			// r_messages が存在することが前提の実装
			return this.r_messages.msg_res_discharge_check_text;//
		},
		// 申請取り下げ確認メッセージ
		msg_confirm_discharge_app:function(){
			// r_messages が存在することが前提の実装
			return this.r_messages.msg_app_discharge_check_text;//
		},
		// データ破棄の確認
		msg_confirm_move_close:function(){
			// r_messages が存在することが前提の実装
			return this.r_messages.confirm_update;
		},
		// 更新ボタン（リロード）時の確認
		msg_confirm_move_restore:function(){
			// r_messages が存在することが前提の実装
			return this.r_messages.confirm_update;
		},
		// コピーボタン時の確認
		msg_confirm_move_copy:function(){
			// r_messages が存在することが前提の実装
			return this.r_messages.confirm_copy;
		},
		// 編集権限確認
		check_edit:function(){
			var apply_mode = false;
			if (this.m_info && this.m_info.editable) {
				apply_mode =  true;
			}
			if(this.edit_btn_disp){
				apply_mode =  true;
			}
			return apply_mode;
		},
	},
	methods: {
		/**
		 * func の参照情報が更新されたタイミングで実行する処理
		 */
		onFuncStateChanged: function(){
			this.m_bConfirmEnable = this.is_confirm_enable;
			this.m_bCopyEnable = this.is_copy_enable;
			this.m_bDeleteEnable = this.is_delete_enable;
			this.m_bRestoreEnable = this.is_restore_enable;
			this.m_bNewDataDisp = this.is_disp_new_btn;
			this.m_bEditDataDisp = this.is_disp_edit_btn;
			this.m_bCopyDisp = this.is_disp_copy_btn;
			this.m_bDeleteDisp = this.is_disp_delete_btn;
			this.m_bErrDetailDisp = this.is_disp_errdetail_btn;
		},
		/**
		 * 前へボタン
		 */
		onBtnPrevious: function(){
			if ( this.$refs.v_param.checkUpdate() ) {
				// 変更あり
				var okCallback = function(){
					this.$refs.func.changeItemPrevious(this.m_strCode,this.m_strCode2);
				}.bind(this);
				this.doCheckDialog( this.msg_confirm_move_close, okCallback);

			} else {
				// 変更なし
				this.$refs.func.changeItemPrevious(this.m_strCode,this.m_strCode2);
			}
		},
		/**
		 * 次へボタン
		 */
		onBtnNext: function(){
			if ( this.$refs.v_param.checkUpdate() ) {
				// 変更あり
				var okCallback = function(){
					this.$refs.func.changeItemNext(this.m_strCode,this.m_strCode2);
				}.bind(this);
				this.doCheckDialog( this.msg_confirm_move_close, okCallback);

			} else {
				// 変更なし
				this.$refs.func.changeItemNext(this.m_strCode,this.m_strCode2);
			}
		},
		/**
		 * 成功メッセージ
		 */
		setSuccessMessage: function( msg, bReset = true ) {
			if ( this.m_bResetMessage ) {
				this.m_message = {result:0,errmessage: msg}
				this.m_bResetMessage = bReset;
			} else {
				this.m_bResetMessage = bReset;
			}
		},
		/**
		 * エラーメッセージ
		 */
		setErrorMessage: function(msg, ext){
			this.m_message = { result: 1, errmessage: msg, ext: ext }
		},
		/**
		 * メッセージクリア
		 */
		clearMessage: function(msg, ext){
			this.m_message = { errmessage:"" }
		},
		/**
		 * 前次ボタン更新処理の終了
		*/
		onNextRefreshEnd: function(retcode, data, msg){
			if(retcode == 0){// 成功
				this.setSuccessMessage(msg);

				this.v_param.m_finishFlg = false;

				if ( data ) { // データが存在する
					this.m_strCode = this.$refs.func.convertInitCode(data);
					this.m_strCode2 = this.$refs.func.convertInitCode2(data);
					this.m_info = this.$refs.func.convertInitData(data);
					this.m_bNew = false;
				} else {
					// データが存在しないため新規として扱う
					this.m_info = this.$refs.func.reset();
					this.m_bNew = true;
				}
			}else{ // エラー処理
				this.setErrorMessage( msg )
			}
		},
		onFreeNumSearchEnd: function(retcode,param,msg){// 空き番号検索終了
			this.m_isFreeNumSearch = false;
			if(retcode == 0)
			{// 成功
				this.setSuccessMessage(msg);
				// this.m_info = this.$refs.func.reset(param);
				switch (this.r_settings.user.display_id) {
					case '040000000000': // 管理会社マスター
					case '040000010000': // ディーラーマスター
					case '030010000000': // 企業
					case '030010010000': // 店舗
					case '030010020000': // 納品情報
						this.m_info = this.$refs.func.reset();
						break;
					default:
						this.m_info = this.$refs.func.reset(param);
				}
				if("code" in param){
					this.m_strCode = param["code"];
				}
				if ( !this.m_bNew) { // 新規フラグがファルスの場合にコード２をresetする。
					this.m_strCode2 = this.$refs.func.resetCode2(this.m_strCode2);
				}
				this.m_bNew = true;

				// 更新通知
				this.$refs.func.onViewStateChange(this.m_bNew,this.m_info,null);
			}
			else{// 失敗
				// エラーメッセージを表示
				this.setErrorMessage(msg)
				return;
			}
		},
		onSubFreeNumSearchEnd: function(retcode,param,msg){// サブ空き番号検索終了
			this.m_isFreeNumSearch = false;
			if(retcode == 0)
			{// 成功
				this.setSuccessMessage(msg);
				this.m_info = this.$refs.func.reset(param);
				if("code" in param){
					this.m_strCode2 = param["code"];
				}
				this.m_bNew = true;

				// 更新通知
				this.$refs.func.onViewStateChange(this.m_bNew,this.m_info,null);
			}
			else{// 失敗
				// エラーメッセージを表示
				this.setErrorMessage(msg)
				return;
			}
		},
		/**
		 * 閉じるボタン <br>
		 * ******* 内部処理 *******<br>
		 * イベントevent_closeを親に投げる。 <br>
		 *
		 * @function  onClose
		 * @returns event_close
		 * @instance
		 */
		onClose: function(param){
			if ( this.$refs.v_param.checkUpdate() ) {
				// 変更あり
				var target = this;
				var okCallback = function(){
					target.$emit('event_close',param);
				};
				this.doCheckDialog( this.msg_confirm_move_close, okCallback);

			} else {
				// 変更なし
				this.$emit('event_close',param);
			}
		},
		onBtnClose: function(){
			this.onClose();
		},
		/**
		 * キーアップイベント <br>
		 * ******* 内部処理 *******<br>
		 * keyupでイベントを受け取り、onBtnClose()を呼ぶ。 <br>
		 *
		 * @function onKeyup
		 * @param {object} e - イベントオブジェクト
		 * @instance
		 */
		onKeyup: function( e ){
			// console.log('keyup');
			// this.onBtnOK();
		},
		/**
		 * クローズイベント <br>
		 * ******* 内部処理 *******<br>
		 * onCloseCopySearch()を呼ぶ。 <br>
		 *
		 * @function  onCloseCopySearch
		 * @param {bool} is - クローズフラグ
		 * @instance
		 */
		onCloseCopySearch: function( is ){
				this.m_bCopySearchDisp = false;
			if ( is ) {
				this.onBtnClose();
			}
		},
		/**
		 * コピー元検索の終了
		 */
		onEndCopySearch: function(info){
			this.m_bCopySearchDisp = false;
			console.log("onEndCopySearch");
			console.log(info);
			// アイテムコピー
			var info = this.$refs.func.copyItem(info,this.m_info);

			// コピー元検索で選択されたデータに強制的に書き換え
			this.v_param.updateInfo( info,true );
			//! データ変更フラグの更新
			this.v_param.updateChangeDataFlag();
		},
		/**
		 * 呼び出しコードの変更イベント
		 */
		onCodeChange: function(val){
			this.clearMessage();

			var isDipsCheckDialog = false;

			var fn = function(val, doValidate){

				var bkCode = this.m_strCode;
				this.m_strCode = val;

				if (doValidate) {
					var is = this.v_param.validateCode();
					if (!is) {
						// 失敗なら
						return;
					}
				}

				// changeItem (searchNext)を実行せずr_codeだけを反映させるため、コード変更による新規 → 更新の切り替えを行わない
				switch (this.r_settings.user.display_id) {
					// 管理会社マスター
					// ディーラーマスター
					// 企業
					// 店舗
					// 部門
					// 納品情報
					case '040000000000':
					case '040000010000':
					case '030010000000':
					case '030010010000':
					case '030010015000':
					case '030010020000':
						console.log("onCodeChange : " + this.m_strCode +" , " + this.m_strCode2);
						this.m_bResetCode2 = true;
						var info = this.v_param.getData();
						var extra = this.v_param.getExtraData();
						this.$refs.func.onViewStateChange(this.m_bNew,info,extra);
						return;
				}

				// 変更前が空白の場合はチェック不要
				if (bkCode == '') {
					console.log("onCodeChange : " + this.m_strCode +" , " + this.m_strCode2);
					this.m_bResetCode2 = true;
					this.$refs.func.changeItem(this.m_strCode,this.m_strCode2);

					var info = this.v_param.getData();
					var extra = this.v_param.getExtraData();
					this.$refs.func.onViewStateChange(this.m_bNew,info,extra);
					return;
				}

				var tmpChecked = this.$refs.v_param.m_bChecked;
				if (tmpChecked == true) {
					console.log("onCodeChange : " + this.m_strCode +" , " + this.m_strCode2);
					this.m_bResetCode2 = true;
					this.$refs.func.changeItem(this.m_strCode,this.m_strCode2);

					var info = this.v_param.getData();
					var extra = this.v_param.getExtraData();
					this.$refs.func.onViewStateChange(this.m_bNew,info,extra);
					return;
				}

				// 変更あり
				if (this.$refs.v_param.checkUpdate(false,false)) {
					var okCallback = function() {
						console.log("onCodeChange : " + this.m_strCode +" , " + this.m_strCode2);
						this.m_bResetCode2 = true;
						this.$refs.func.changeItem(this.m_strCode,this.m_strCode2);

						var info = this.v_param.getData();
						var extra = this.v_param.getExtraData();
						// 申請コメント、適用日を待避
						this.v_param.backupApplicantComment(info);
						if (this.m_strCode == '') {
							// コード未入力に変わったらviewParamの保持データを初期化
							// 栄養成分構成の場合はクリアしない（タブ選択状態をm_strCode2で判別しているため）
							// POPイメージの場合はクリアしない（機種区分をm_strCode2に保持しているため）
							if (this.r_settings.user.display_id != '030050000000' &&
								this.r_settings.user.display_id != '030020000000') {
								this.m_strCode2 = '';
							}
							// 原料原産地の場合
							if (this.r_settings.user.display_id == '030010160000') {
								// 展開位置の変更フラグが残るため編集中フラグを初期化する
								this.$refs.v_param.m_isChangeNotCharge = false;
							}

							// 新規モードに切り替え
							this.m_bNew = true;

							var storeCode = '';
							var storeName = '';
							if (this.r_settings.user.display_id == '030030080000') {
								// 店名予約の特殊処理（店舗コード、名称を待避）
								storeCode = info.store_code;
								storeName = info.store_name;
							}
							// 新規データで上書き
							info = $.extend(true,{},this.v_param.manager.createNewData(null,1));
							if (this.r_settings.user.display_id == '030030080000') {
								// 店名予約の特殊処理（店舗コード、名称を再適用）
								info.store_code = storeCode;
								info.store_name = storeName;
							}

							this.$nextTick(function() {
								// 待避した申請コメント、適用日を再適用
								info = this.setApplicantComment(info);

								this.v_param.updateInfo(info, false);
								this.v_param.updateChangeDataFlag();
								this.v_param.clearMessage();
							});
						}
						this.$refs.func.onViewStateChange(this.m_bNew,info,extra);
					}.bind(this);
					var ngCallback = function() {
						this.m_isFreeNumSearch = false;
						if (tmpChecked != undefined) {
							this.$refs.v_param.m_bChecked = tmpChecked;
						}
						this.m_strCode = bkCode;
						// WEB承認者の場合
						if (this.r_settings.user.display_id == '070010020000'){
							// 更新されているコードを元に戻す
							console.log(this.v_param.m_info.user_id);
							this.v_param.m_info.user_id = bkCode;
						}

						this.$nextTick(function () {
							this.v_param.validateCode();
						});
					}.bind(this);
					// this.doCheckDialog(this.msg_confirm_move_close, okCallback, ngCallback);

					if (this.m_isFreeNumSearch && this.m_strCode != '') {
						this.m_isFreeNumSearch = false;
						okCallback();
					} else {
						// this.doCheckDialog(this.msg_confirm_move_close, okCallback, ngCallback);
						if (isDipsCheckDialog) {
							this.doCheckDialog(this.msg_confirm_move_close, okCallback, ngCallback);
						} else {
							okCallback();
						}
					}

				// 変更なし
				} else {
					console.log("onCodeChange : " + this.m_strCode +" , " + this.m_strCode2);
					this.m_bResetCode2 = true;
					this.$refs.func.changeItem(this.m_strCode,this.m_strCode2);

					var info = this.v_param.getData();
					var extra = this.v_param.getExtraData();
					// 申請コメント、適用日を待避
					this.v_param.backupApplicantComment(info);
					if (this.m_strCode == '') {
						// コード未入力に変わったらviewParamの保持データを初期化
						// 栄養成分構成の場合はクリアしない（タブ選択状態をm_strCode2で判別しているため）
						// POPイメージの場合はクリアしない（機種区分をm_strCode2に保持しているため）
						if (this.r_settings.user.display_id != '030050000000' &&
							this.r_settings.user.display_id != '030020000000') {
							this.m_strCode2 = '';
						}
						// 新規モードに切り替え
						this.m_bNew = true;

						var storeCode = '';
						var storeName = '';
						if (this.r_settings.user.display_id == '030030080000') {
							// 店名予約の特殊処理（店舗コード、名称を待避）
							storeCode = info.store_code;
							storeName = info.store_name;
						}
						// 新規データで上書き
						info = $.extend(true,{},this.v_param.manager.createNewData(null,1));
						if (this.r_settings.user.display_id == '030030080000') {
							// 店名予約の特殊処理（店舗コード、名称を再適用）
							info.store_code = storeCode;
							info.store_name = storeName;
						}

						this.$nextTick(function() {
							// 待避した申請コメント、適用日を再適用
							info = this.setApplicantComment(info);

							this.v_param.updateInfo(info, false);
							this.v_param.updateChangeDataFlag();
							this.v_param.clearMessage();
						});
					}
					this.$refs.func.onViewStateChange(this.m_bNew,info,extra);
				}
			}.bind(this);

			// // コードがクリアされた場合バリデーションを無視する
			// var doValidate = (this.m_strCode != '' && val == '') ? false : true;
			// fn(val, doValidate);
			switch (this.r_settings.user.display_id) {
				// // 管理会社マスター
				// // ディーラーマスター
				// case '040000000000':
				// case '040000010000':
				// 	var url = this.v_param.manager.createRefreshURL(this.r_class_code, val);
				// 	var callbackOK = function(rResponse) {
				// 		console.log("refresh success : " + rResponse.data["result"]);
				// 		console.log(rResponse);
				// 		if (rResponse.data.allcount > 0) {
				// 			isDipsCheckDialog = true;
				// 		} else {
				// 			// 更新→新規
				// 			if (!this.v_param.r_is_new) {
				// 				isDipsCheckDialog = true;
				// 			}
				// 		}
				// 		// コードがクリアされた場合バリデーションを無視する
				// 		var doValidate = (this.m_strCode != '' && val == '') ? false : true;
				// 		fn(val, doValidate);
				// 	}.bind(this);
				// 	var callbackNG = function(rResponse) {
				// 		console.log("refresh error");
				// 		console.log(rResponse);
				// 	}.bind(this);

				// 	this.v_param.manager.access(url, callbackOK, callbackNG);
				// 	break;
				// 管理会社マスター
				// ディーラーマスター
				// 企業
				// 店舗
				// 納品情報
				case '040000000000':
				case '040000010000':
				case '030010000000':
				case '030010010000':
				case '030010020000':
					// 更新→新規
					if (!this.v_param.r_is_new) {
						isDipsCheckDialog = true;
					}
					// コードがクリアされた場合バリデーションを無視する
					var doValidate = (this.m_strCode != '' && val == '') ? false : true;
					fn(val, doValidate);
					break;
				// その他
				default:
					isDipsCheckDialog = true;
					// コードがクリアされた場合バリデーションを無視する
					var doValidate = (this.m_strCode != '' && val == '') ? false : true;
					fn(val, doValidate);
					break;
			}
		},
		onCodeChange2: function(val, flg) {
			this.clearMessage();

			var fn = function(val, doValidate){


				var bkCode = this.m_strCode2;
				if (!flg) {
					this.m_strCode2 = val;
				} else {
					this.m_strCode2 = decodeURIComponent(val);
				}

				if (doValidate) {
					var is = this.v_param.validateCode();
					if (!is) {
						// 失敗なら
						return;
					}
				}

				switch (this.r_settings.user.display_id) {
					// アカウント管理
					case '030020000000':
					case '030020010000':
					case '030020020000':
						console.log("onCodeChange2 : " + this.m_strCode +" , " + this.m_strCode2);
						var info = this.v_param.getData();
						var extra = this.v_param.getExtraData();
						this.$refs.func.onViewStateChange(this.m_bNew,info,extra);
						return;
				}

				// 変更前が空白の場合はチェック不要
				if (bkCode == '') {
					console.log("onCodeChange2 : " + this.m_strCode +" , " + this.m_strCode2);
					this.$refs.func.changeItem(this.m_strCode,this.m_strCode2);

					var info = this.v_param.getData();
					var extra = this.v_param.getExtraData();
					this.$refs.func.onViewStateChange(this.m_bNew,info,extra);
					return;
				}

				var tmpChecked = this.$refs.v_param.m_bChecked;

				// 変更あり
				if (this.$refs.v_param.checkUpdate(false,false)) {
					var okCallback = function() {
						this.$refs.v_param.m_bChecked = false;
						console.log("onCodeChange2 : " + this.m_strCode +" , " + this.m_strCode2);
						this.$refs.func.changeItem(this.m_strCode,this.m_strCode2);

						var info = this.v_param.getData();
						var extra = this.v_param.getExtraData();
						// 申請コメント、適用日を待避
						this.v_param.backupApplicantComment(info);
						if (this.m_strCode2 == '') {
							// コード未入力に変わったらviewParamの保持データを初期化して新規モード
							this.m_bNew = true;
							info = $.extend(true,{},this.v_param.manager.createNewData(null,1));
							this.$nextTick(function() {
								// 待避した申請コメント、適用日を再適用
								info = this.setApplicantComment(info);

								this.v_param.updateInfo(info, false);
								this.v_param.updateChangeDataFlag();
								this.v_param.clearMessage();
							});
						}
						this.$refs.func.onViewStateChange(this.m_bNew,info,extra);
					}.bind(this);
					var ngCallback = function() {
						this.m_isFreeNumSearch = false;
						if (tmpChecked != undefined) {
							this.$refs.v_param.m_bChecked = tmpChecked;
						}
						this.m_strCode2 = bkCode;
						this.$nextTick(function () {
							this.v_param.validateCode();
						});
					}.bind(this);

					if (this.m_isFreeNumSearch && this.m_strCode2 != '') {
						this.m_isFreeNumSearch = false;
						okCallback();
					} else {
						if (this.r_settings.user.display_id == '070010060000' && this.v_param.m_store_change_flag) {
							// 接続機器で店舗変更時はすでに破棄確認を行なっているため
							okCallback();
						}else {
							// this.doCheckDialog(this.msg_confirm_move_close, okCallback, ngCallback);
							switch (this.r_settings.user.display_id) {
								// アカウント作成
								case '030020000000':
								case '030020010000':
								case '030020020000':
									var url = this.v_param.manager.createRefreshURL(0, this.m_strCode2);
									var callbackOK = function(rResponse) {
										console.log("refresh success : " + rResponse.data["result"]);
										console.log(rResponse);
										if (rResponse.data.allcount > 0) {
											this.doCheckDialog(this.msg_confirm_move_close, okCallback, ngCallback);
										} else {
											// okCallback();
										}
									}.bind(this);
									var callbackNG = function(rResponse) {
										console.log("refresh error");
										console.log(rResponse);
									}.bind(this);

									this.v_param.manager.access(url, callbackOK, callbackNG);
									break;
								// その他
								default:
									this.doCheckDialog(this.msg_confirm_move_close, okCallback, ngCallback);
									break;
							}
						}
					}

				// 変更なし
				} else {
					console.log("onCodeChange2 : " + this.m_strCode +" , " + this.m_strCode2);
					this.$refs.func.changeItem(this.m_strCode,this.m_strCode2);

					var info = this.v_param.getData();
					var extra = this.v_param.getExtraData();
					// 申請者コメント、適用日を待避
					this.v_param.backupApplicantComment(info);

					if (this.m_strCode2 == '') {
						// コード未入力に変わったらviewParamの保持データを初期化して新規モード
						this.m_bNew = true;
						info = $.extend(true,{},this.v_param.manager.createNewData(null,1));
						this.$nextTick(function() {
							// 待避した申請コメント、適用日を再適用
							info = this.setApplicantComment(info);

							this.v_param.updateInfo(info, false);
							this.v_param.updateChangeDataFlag();
							this.v_param.clearMessage();
						});
					}
					this.$refs.func.onViewStateChange(this.m_bNew,info,extra);
				}
			}.bind(this);

			// コードがクリアされた場合バリデーションを無視する
			var doValidate = (this.m_strCode2 != '' && val == '') ? false : true;
			if (this.r_settings.user.display_id == '050010020000') {
				// ユーザーマスターの特殊判定
				var code = this.v_param.$refs.v_basic.$refs.v_user_id.value;
				doValidate = (code == '') ? false : true;
			}
			fn(val, doValidate);
		},
		setApplicantComment:function(info){
			info.applicant_comment = this.v_param.m_strApplicantComment;
			info.date_from = this.v_param.m_strDateFrom;
			info.date_to = this.v_param.m_strDateTo;
			return info;
		},
		//! ビュー状態の変更を func に通知する
		onViewStateChange: function(val){
			console.log("onViewStateChange : " + val);
			var info = this.v_param.getData();
			var extra = this.v_param.getExtraData();
			this.$refs.func.onViewStateChange(this.m_bNew,info,extra);
		},
		/**
		 * コピー元検索
		 */
		onBtnCopySearch: function(){
			if(this.m_bCopySearchDisp == false){
				// 編集中データ取得
				this.m_infoEdit = this.v_param.getData();

				this.m_bCopySearchDisp = true;

				this.setDispTimer("div#copysearch-window",200);
			}
		},
		/**
		 * codeの空き番号検索
		 */
		onBtnFreeNumSearch: function(val){
			// 変更前が空の場合はチェック不要
			if (this.m_strCode == '') {
				this.m_isFreeNumSearch = true;

				// 申請コメント、適用日を待避
				var info = this.v_param.getData();
				this.v_param.backupApplicantComment(info);

				this.$refs.func.reqFreeNumSearch(val);
				return;
			}

			switch (this.r_settings.user.display_id) {
				// 管理会社マスター
				// ディーラーマスター
				// 企業
				// 店舗
				// 納品情報
				case '040000000000':
				case '040000010000':
				case '030010000000':
				case '030010010000':
				case '030010020000':
					// 申請コメント、適用日を待避
					var info = this.v_param.getData();
					this.v_param.backupApplicantComment(info);
					this.$refs.func.reqFreeNumSearch(val);
					return;
			}

			// 変更あり
			var tmpChecked = this.$refs.v_param.m_bChecked;
			if (this.$refs.v_param.checkUpdate(false,false)) {
				var okCallback = function() {
					this.m_isFreeNumSearch = true;

					// 申請コメント、適用日を待避
					var info = this.v_param.getData();
					this.v_param.backupApplicantComment(info);

					this.$refs.func.reqFreeNumSearch(val);
				}.bind(this);
				var ngCallback = function() {
				    if (tmpChecked != undefined) {
						this.$refs.v_param.m_bChecked = tmpChecked;
						if (this.$refs.v_param.cancelChangeStore) {
							// 接続機器マスターのみ特殊
							// キャンセル時に店舗コードを戻す処理
							this.$refs.v_param.cancelChangeStore();
						}
					}
				}.bind(this);
				this.doCheckDialog(this.msg_confirm_move_close, okCallback, ngCallback);
			// 変更なし
			} else {
				// 申請コメント、適用日を待避
				var info = this.v_param.getData();
				this.v_param.backupApplicantComment(info);

				this.$refs.func.reqFreeNumSearch(val);
			}
		},
		/**
		 * code2の空き番号検索
		 */
		onBtnSubFreeNumSearch: function(val){
			// 変更前が空の場合はチェック不要
			if (this.m_strCode == '') {
				// 申請コメント、適用日を待避
				var info = this.v_param.getData();
				this.v_param.backupApplicantComment(info);

				this.$refs.func.reqSubFreeNumSearch(val);
				return;
			}

			// 変更あり
			var tmpChecked = this.$refs.v_param.m_bChecked;
			if (this.$refs.v_param.checkUpdate(false,false)) {
				var okCallback = function() {
					// 申請コメント、適用日を待避
					var info = this.v_param.getData();
					this.v_param.backupApplicantComment(info);

					this.$refs.func.reqSubFreeNumSearch(val);
				}.bind(this);
				var ngCallback = function() {
				    if (tmpChecked != undefined) {
						this.$refs.v_param.m_bChecked = tmpChecked;
					}
				}.bind(this);
				this.doCheckDialog(this.msg_confirm_move_close, okCallback, ngCallback);

			// 変更なし
			} else {
				// 申請コメント、適用日を待避
				var info = this.v_param.getData();
				this.v_param.backupApplicantComment(info);

				this.$refs.func.reqSubFreeNumSearch(val);
			}
		},
		onErrMessage: function(val){
			this.setErrorMessage(val)
		},
		/*
		* 確認ダイアログを表示する。
		* OKボタンが押された場合コールバックを呼ぶ。
		*/
		doCheckDialog: function(msg_confirm, okCallback, ngCallback = null) {
			// アクティブな要素のフォーカスを外す
			this.blurActiveElement();
			var target = this;
			var isClicked = false;
			$.confirm({ // 確認ダイアログを表示する。
				title: '',
				content: msg_confirm,
				buttons: {
					ok: {
						text: this.r_messages.yes_btn,
						btnClass: 'btn-ok',
						action: function() {
							if (isClicked) return; // ダブルクリック抑制
							isClicked = true;
							okCallback();
						}
					},
					cancel: {
						text: this.r_messages.no_btn,
						btnClass: 'btn-cancel',
						action: function() {
							if ( ngCallback != null ) {
								ngCallback();
							}
						}
					}
				},
				onOpen: function(){
					target.toggleTabIndexConfirm(true);
				},
				onClose: function(){
					target.toggleTabIndexConfirm(false);
				},
			});
		},
		/*
		* 確認ダイアログ(複数ボタン)を表示する。
		* OKボタンが押された場合コールバックを呼ぶ。
		* 連続登録用
		*/
		doCheckDialogMultiButton: function(msg_confirm, okCallback, okCallback2, ngCallback = null) {
			// アクティブな要素のフォーカスを外す
			this.blurActiveElement();
			var target = this;
			var isClicked = false;
			$.confirm({ // 確認ダイアログを表示する。
				title: '',
				content: msg_confirm,
				buttons: {
					ok: {
						text: this.r_messages.regist_btn,
						btnClass: 'btn-ok',
						action: function() {
							if (isClicked) return; // ダブルクリック抑制
							isClicked = true;
							okCallback();
						}
					},
					ok2: {
						text: this.r_messages.continuou_regist_btn,
						btnClass: 'btn-ok',
						action: function() {
							if (isClicked) return; // ダブルクリック抑制
							isClicked = true;
							okCallback2();
						}
					},
					cancel: {
						text: this.r_messages.no_btn,
						btnClass: 'btn-cancel',
						action: function() {
							if ( ngCallback != null ) {
								ngCallback();
							}
						}
					}
				},
				onOpen: function(){
					target.toggleTabIndexConfirm(true);
				},
				onClose: function(){
					target.toggleTabIndexConfirm(false);
				},
			});
		},
		/**
		 * 詳細画面で表紙するデータのコピーが終わったことを知らせるイベント <br>
		 * ******* 内部処理 *******<br>
		 * 編集中のデータで書き換える。 <br>
		 *
		 * @function  onEndCopyInfo
		 * @instance
		 */
		onEndCopyInfo: function() {
			console.log("[ onEndCopyInfo ] ");
			if ( this.r_info_edit ) {
				var info = $.extend(true,{},this.r_info_edit);
				// メインリストで編集したデータに書き換え
				this.v_param.updateInfo( info );
				var code = this.$refs.func.convertInitCode(info);
				var code2 = this.$refs.func.convertInitCode2(info);
				this.v_param.updateCode( code, code2 );
				//! データ変更フラグの更新
				this.v_param.updateChangeDataFlag();

				this.m_strCode = code;
				this.m_strCode2 = code2;
			}
		},
		blurActiveElement: function() {
			// アクティブな要素のフォーカスを外す
			document.activeElement.blur();
		},
		/**
		 * 日付フォーカスインイベント(予約/申請)
		 */
		onFocusDate: function(){
			// 操作ボタンを非活性にする
			this.m_bConfirmEnable = false;
			this.m_bCopyEnable = false;
			this.m_bDeleteEnable = false;
			this.m_bRestoreEnable = false;
		},
		/**
		 * 日付フォーカスアウトイベント(予約/申請)
		 */
		onBlurDate: function(){
			// 操作ボタンの状態を戻す
			this.onFuncStateChanged();
		}
	},
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/common/wndDetailBase.mixin.vue